import { useEffect, useState } from "react";

const KEY = "striply_ink_sprites";
const EVENT = "striply:ink-sprites";

/** "on" (default), "off", or "eager" (appear after a short pause — for demos). */
export const getInkSpritesSetting = () => {
  try {
    const value = localStorage.getItem(KEY);
    if (value === "0") return "off";
    if (value === "eager") return "eager";
  } catch (e) {
    // storage unavailable: default on
  }
  return "on";
};

export const setInkSpritesEnabled = (enabled) => {
  try {
    if (enabled) localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, "0");
  } catch (e) {
    // non-fatal
  }
  window.dispatchEvent(new Event(EVENT));
};

/** Live setting, shared across components (and pages) via a window event. */
export const useInkSpritesSetting = () => {
  const [setting, setSetting] = useState(getInkSpritesSetting);
  useEffect(() => {
    const sync = () => setSetting(getInkSpritesSetting());
    window.addEventListener(EVENT, sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener(EVENT, sync);
      window.removeEventListener("storage", sync);
    };
  }, []);
  return setting;
};
